/**
 * Repositories event types for real-time notifications and durable event recording.
 */
export enum RepositoriesEventType {
  REPO_CREATED = 'repositories:repo-created',
  BRANCH_CREATED = 'repositories:branch-created',
  INSTANCE_PROVISIONED = 'repositories:instance-provisioned',
  BRANCH_SYNCED = 'repositories:branch-synced',
  PR_OPENED = 'repositories:pr-opened',
  PR_SYNCHRONIZED = 'repositories:pr-synchronized',
  PR_CLOSED = 'repositories:pr-closed',
  /** Neon COW clone-index: new branch + git source inheriting the parent watermark (IDX-3). */
  INDEX_CLONED = 'repositories:index-cloned',
}

/**
 * Pub/sub channel for repositories events.
 */
export const REPOSITORIES_EVENTS_CHANNEL = 'repositories:events';